export default __webpack_public_path__ + "static/media/5f6d9f0ff63ada998fcaf0114e3dc7851581616795088.3c8ff8fd.webp";